/**
 * Slug -> display name for Uruguay's departments.
 *
 * Presentation only; the SLUG is what is ever stored and compared. Its own
 * module rather than living beside the picker, because a file that exports both
 * a component and a helper breaks Fast Refresh — the lint rule that says so is
 * right, and the helper is used by both the profile card and the picker.
 *
 * WHY A MAP AND NOT TITLE-CASE. This used to de-hyphenate the slug and
 * capitalise each part, which is correct for thirteen of the nineteen and
 * WRONG for the rest — it rendered "Paysandu", "San Jose", "Tacuarembo",
 * "Rio Negro" and "Treinta Y Tres" to Uruguayan professionals reading the
 * names of their own departments. The slugs are accent-stripped on purpose
 * (they are identifiers), so the accents cannot be derived back out of them;
 * the display names have to be written down.
 *
 * Note "Treinta y Tres" keeps its conjunction lowercase, which is the other
 * thing a mechanical title-case gets wrong.
 */
const DEPARTMENT_NAMES: Readonly<Record<string, string>> = {
  artigas: "Artigas",
  canelones: "Canelones",
  "cerro-largo": "Cerro Largo",
  colonia: "Colonia",
  durazno: "Durazno",
  flores: "Flores",
  florida: "Florida",
  lavalleja: "Lavalleja",
  maldonado: "Maldonado",
  montevideo: "Montevideo",
  paysandu: "Paysandú",
  "rio-negro": "Río Negro",
  rivera: "Rivera",
  rocha: "Rocha",
  salto: "Salto",
  "san-jose": "San José",
  soriano: "Soriano",
  tacuarembo: "Tacuarembó",
  "treinta-y-tres": "Treinta y Tres",
};

export function departmentLabel(slug: string): string {
  const known = DEPARTMENT_NAMES[slug];
  if (known != null) return known;

  /*
    FALLBACK, for a vocabulary the server grew before this map did. The
    picker renders whatever the server serves, so an unknown slug must still
    read as something rather than disappear — de-hyphenated and capitalised,
    which is what every name here used to be.
  */
  return slug
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
